export default "__VITE_ASSET__BOBqc32m__"